import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "react-toastify";
import apiService from "../services/apiService";

const EditChapter = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [chapter, setChapter] = useState({
    description: "",
    title: "",
    audio: "",
    chapter_type: "1",
    content_id: "",
    songNumber: "",
    duration: "",
    selected_content_title: "",
  });

  useEffect(() => {
    fetchChapter();
  }, []);

  const fetchChapter = async () => {
    try {
      const res = await apiService.fetchData(`admin/get-chapter/${id}`);
      if (!res.error && res.data) {
        setChapter((prev) => ({
          ...prev,
          description: res.data.description || "",
          songNumber: res.data.songNumber || "",
          duration: res.data.duration || "",
          title: res.data.title || "",
          // chapter_type: res.data.chapter_type?.toString() || "1",
          content_id: res.data.content_id || "",
          selected_content_title: res.data.ChaptersToContentDetails?.title || "",
          audio: res.data.audio_file || "",
        }));
      }
    } catch (err) {
      toast.error("Error fetching chapter.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChapter({ ...chapter, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = {
      description: chapter.description,
      title: chapter.title,
      // chapter_type: chapter.chapter_type,
      content_id: chapter.content_id,
      songNumber: chapter.songNumber,
      // Ensure that duration is treated as a string before calling .trim()
      duration: chapter.duration ? chapter.duration.toString().trim() : "0", // Default to "0" if undefined or null
      audio_file: chapter.audio, // Using audio URL directly
    };
  
    try {
      const res = await apiService.putData(`admin/update-chapter/${id}`, payload, true);
      if (!res.error) {
        toast.success("Chapter updated!");
        navigate("/chapters");
      }
    } catch {
      toast.error("Update failed.");
    }
  };
    return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h4>Edit Chapter</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              {/* Content Search */}
              <div className="form-group position-relative">
                <label>Select Content</label>
                <input
                  type="text"
                  name="selected_content_title"
                  className="form-control"
                  value={chapter.selected_content_title || ""}
                  onChange={handleChange}
                  placeholder="Search Content"
                  autoComplete="off"
                />
              </div>

              {/* Chapter Title */}
              <div className="form-group mt-3">
                <label>Chapter Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={chapter.title}
                  onChange={handleChange}
                  placeholder="Enter Chapter Title"
                />
              </div>

              {/* Description */}
              <div className="form-group mt-3">
                <label>Description</label>
                <textarea
                  name="description"
                  className="form-control"
                  value={chapter.description}
                  onChange={handleChange}
                  placeholder="Enter Description"
                />
              </div>

              {/* Song Number */}
              <div className="form-group mt-3">
                <label>Song Number</label>
                <input
                  type="text"
                  name="songNumber"
                  className="form-control"
                  value={chapter.songNumber}
                  onChange={handleChange}
                  placeholder="Enter song number"
                />
              </div>

              {/* Duration */}
              <div className="form-group mt-3">
                <label>Duration</label>
                <input
                  type="text"
                  name="duration"
                  className="form-control"
                  value={chapter.duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                />
              </div>

              {/* Chapter Type */}
              {/* <div className="form-group mt-3">
                <label>Chapter Type</label>
                <div>
                  {["1", "2", "3"].map((val) => (
                    <label key={val} className="me-3">
                      <input
                        type="radio"
                        name="chapter_type"
                        value={val}
                        checked={chapter.chapter_type === val}
                        onChange={handleChange}
                      />{" "}
                      {val === "1" ? "Story" : val === "2" ? "Learning" : "Song"}
                    </label>
                  ))}
                </div>
              </div> */}

              {/* Audio URL */}
              <div className="form-group mt-3">
                <label htmlFor="audio-url" className="form-label">Enter Audio URL</label>
                <div className="input-group">
                  <span 
                    className="input-group-text" 
                    id="audio-addon" 
                    style={{ color: '#6c757d', backgroundColor: '#e9ecef' }}
                  >
                    https://playzippy.s3.amazonaws.com/
                  </span>
                  <input
                    type="text"
                    name="audio"
                    className="form-control"
                    id="audio-url"
                    value={chapter.audio} 
                    onChange={handleChange} 
                    placeholder="Enter file name or path"
                    aria-describedby="audio-addon"
                  />
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="d-flex gap-2 mt-4">
                <button type="submit" className="btn btn-primary">
                  <Plus size={16} /> Update Chapter
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => navigate("/chapters")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditChapter;
